import ChatMessageView from './ChatMessage.View';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import { ChatMessageProps } from './types';

const ChatMessage = (props: ChatMessageProps) => {
  const { content, onFeedbackClick } = props;
  const copyToClipboard = useCopyToClipboard();

  const onCopyClick = async () => {
    function cleanText(input: string): string {
      /* Remove HTML tags */
      return (
        input
          .replace(/<[^>]*>/g, '')
          /* Replace multiple newlines or carriage returns with a single space */
          .replace(/[\r\n]+/g, ' ')
          /* Replace multiple spaces/tabs with a single space */
          .replace(/\s+/g, ' ')
          /* Trim whitespace from both ends */
          .trim()
      );
    }

    const cleanCopy = cleanText(content);

    await copyToClipboard(cleanCopy);
  };

  return <ChatMessageView {...props} onCopyClick={onCopyClick} onFeedbackClick={onFeedbackClick} />;
};

export default ChatMessage;
